import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActionSelectorOption } from './action-selector.interface';

@Component({
  selector: 'app-action-selector',
  templateUrl: './action-selector.component.html',
  styleUrls: ['./action-selector.component.scss']
})
export class ActionSelectorComponent implements OnInit {

  selectedType: string;
  actionSelectorOption: ActionSelectorOption;

  constructor(
    public dialogRef: MatDialogRef<ActionSelectorComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData
  ) { }

  ngOnInit(): void {
    this.actionSelectorOption = this.dialogData?.data;
    if (this.actionSelectorOption.options?.length && this.actionSelectorOption.options[0]?.key) {
      this.selectedType = this.actionSelectorOption.options[0]?.key;
    }
  }

  confirmSelection(): void {
    this.dialogRef.close({ isSelected: true, selectedType: this.selectedType });
  }

  closeDialog(): void {
    this.dialogRef.close({ isSelected: false });
  }

}
